import { Howl } from "howler";
import DelayedOrderSound from "../../../assets/audio/atraso-upgas.mp3";
import DelayedOrderSoundOgg from "../../../assets/audio/atraso-upgas.ogg";
import DengSound from "../../../assets/audio/deng.mp3";
import DengSoundOgg from "../../../assets/audio/deng.ogg";

class SoundService {
  constructor() {
    this.DelayedSoundInstance = new Howl({
      src: [DelayedOrderSound, DelayedOrderSoundOgg],
      onloaderror: (id, err) => console.log(`order sound player load error: ${err}`),
      onplayerror: (err) => console.log(`order sound player play error: ${err}`)
    });

    this.CanceledSoundInstance = new Howl({
      src: [DengSound, DengSoundOgg],
      loop: true,
      onloaderror: (id, err) => console.log(`order sound player load error: ${err}`),
      onplayerror: (err) => console.log(`order sound player play error: ${err}`)
    });
  }

  playSound() {
    this.DelayedSoundInstance.play();
  }

  playCanceledSound() {
    this.CanceledSoundInstance.play();
  }

  stopCanceledSound() {
    this.CanceledSoundInstance.stop();
  }
}

const soundService = new SoundService();
export default soundService;
